import { Order } from "./OrderContext";
import { useUser } from "../../hooks/useUser";

const ORDER_DRAFT_KEY_PREFIX = "order-draft";
// Unscoped key used before drafts were per user; it may hold another user's draft.
const LEGACY_ORDER_DRAFT_KEY = "order";

export function getOrderDraftKey(
  accountId: string | null | undefined,
  userId: string | null | undefined
): string | null {
  if (!accountId || !userId) {
    return null;
  }
  return `${ORDER_DRAFT_KEY_PREFIX}:${accountId}:${userId}`;
}

export function useOrderDraftKey(): string | null {
  const { details } = useUser();
  return getOrderDraftKey(details?.client_account?.id, details?.id);
}

export function loadOrderDraft(key: string | null): Order | null {
  localStorage.removeItem(LEGACY_ORDER_DRAFT_KEY);
  if (!key) {
    return null;
  }
  const draft = localStorage.getItem(key);
  return draft ? JSON.parse(draft) : null;
}

export function saveOrderDraft(key: string | null, order: Order) {
  if (key) {
    localStorage.setItem(key, JSON.stringify(order));
  }
}

export function clearOrderDraft(key: string | null) {
  if (key) {
    localStorage.removeItem(key);
  }
}
